import ClientConfiguration from "./client_config.json";
import { hubBasePath } from "../utils/hubBasePath";
window.TVSite = window.TVSite || {};

class ClientConfigurationHelper {
    constructor() {
        this.configuration = ClientConfiguration.client_config;// TVSite.client_config;
        this.setUrls();
        this.setClientHash();
        this.setPhpEnv();
        TVSite.apiUrl = ClientConfiguration.apiUrl;
        TVSite.newApiBaseUrl = ClientConfiguration.newApiBaseUrl;
        TVSite.apiBaseUrlV3 = ClientConfiguration.apiBaseUrlV3;
    }
    enableHeaderFooter(){
        if(TVSite && TVSite.hasOwnProperty("enableHeaderFooter"))
            return TVSite.enableHeaderFooter;
        else
            return true;
    }
    getSection = (section) =>{
        if(this.configuration[section]){
            return this.configuration[section]
        }else{
            return null;
        }
    }
    hasStrLen = (srt) => {if(srt) return (srt.length && srt.length > 0) || /[a-z0-9]/i.test(srt)}
    setUrls =()=>{
            const {public_base_url, sub_folder} = this.configuration?.experiences?.publishing;
            TVSite.public_base_url = this.hasStrLen(public_base_url) ? public_base_url : '';
            const configuredSubFolder = this.hasStrLen(sub_folder) ? "/"+sub_folder.split('/').filter(f=>!!f).join('/') : '';
            TVSite.sub_folder = hubBasePath(typeof window !== "undefined" ? window.location.pathname : "", configuredSubFolder, this.configuration?.client?.id);
    }
    setClientHash =()=>{
        if(this.configuration && this.configuration.client && this.configuration.client.hash)
            TVSite.clientHash = this.configuration.client.hash;
        else
            TVSite.clientHash = "Missing client hash"
    }
    setPhpEnv =()=>{
        if(ClientConfiguration && ClientConfiguration.php_env_name)
            TVSite.phpEnvName = ClientConfiguration.php_env_name;
        else
            TVSite.phpEnvName = "Missing phpEnvName"
    }
    getCurrencySymbol=()=>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.currency_symbol) {
            return this.configuration.experiences.currency_symbol;
        }else
            return '$'
    }
    getPlayerSharing=()=>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hub &&
            !!this.configuration.experiences.hub.sharing) {
            const sharing = this.configuration.experiences.hub.sharing;
            if(!sharing.domain)
                sharing.domain = sharing.base_url;
            return sharing;
        }else
            return null
    }
    getLatestVideosChannelId = () => {
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub &&
            this.configuration.experiences.hub.channels && this.configuration.experiences.hub.channels.latest &&
            this.configuration.experiences.hub.channels.latest > 0)
            return this.configuration.experiences.hub.channels.latest;
        else
            console.log("Missing latest channel id in client config");
    }
    getRelatedVideosChannelId = () => {
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub &&
            this.configuration.experiences.hub.channels && this.configuration.experiences.hub.channels.related &&
            this.configuration.experiences.hub.channels.related > 0)
            return this.configuration.experiences.hub.channels.related;
        else
            console.log("Missing latest channel id in client config");
    }
    useRecommendedProducts(){
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub && this.configuration.experiences.hub.recommendedProducts)
            return this.configuration.experiences.hub.recommendedProducts;
        else
            return true;
    }
    isAmbassadorProgramEnabled(){
        if(this.configuration && this.configuration.client)
            return this.configuration.client.ambassador_program_enabled;
        else
            return false;
    }
    productThumbnailPresentation(){
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub && this.configuration.experiences.hub.keepProductsAspectRatio)
            return "keep-aspect-ratio";
        else
            return "cover-mode";
    }
    getExperienceTitle(){
        if (this.configuration && this.configuration.experiences && this.configuration.experiences.hub && this.configuration.experiences.hub.title)
            return this.configuration.experiences.hub.title;
        else
            return "(Experience name)";
    }
    getDefaultLogo(){
        if(this.configuration && this.configuration.client.brand.logo && this.configuration.client.brand.logo)
            return this.configuration.client.brand.logo.default;
        else
            return "";
    }
    getClientSiteLinks () {
        if (this.configuration && this.configuration.client && this.configuration.client.links)
            return this.configuration.client.links;
        else
            return {};
    }
    getGlobalConfiguration = () => {
        if (window.hasOwnProperty("TVSite"))
            return window.TVSite;
        else
            throw new Error("global instance TVSite not available");
    }
    useAffiliateProductsLink = () =>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hasOwnProperty('enable_affiliate_short_link'))
            return this.configuration.experiences.enable_affiliate_short_link;
        else
            return false;
    }

    getSignInSettings = () => {
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hasOwnProperty('hub') && this.configuration.experiences.hub.hasOwnProperty('sign_in'))
            return this.configuration.experiences.hub.sign_in;
        else
            return false;
    }

    getDashboardSection = () => {
        if(this.configuration && this.configuration.dashboards)
            return this.configuration.dashboards;
        else
            return false;
    }
    getProductsCTAText = () =>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hasOwnProperty('hub') && this.configuration.experiences.hub.hasOwnProperty('product_cta_text'))
            return this.configuration.experiences.hub.product_cta_text;
        else
            return "BUY NOW";
    }
    getProductsCTAModalText = () =>{
        if(this.configuration && this.configuration.experiences && this.configuration.experiences.hasOwnProperty('hub') && this.configuration.experiences.hub.hasOwnProperty('product_cta_modal_text'))
            return this.configuration.experiences.hub.product_cta_modal_text;
        else
            return "BUY NOW";
    }
    getCategories = () => {
        if(this.configuration?.client?.custom_fields?.asset?.category?.data?.options){
            return this.configuration?.client?.custom_fields?.asset?.category?.data?.options;
        }else{
            return [];
        }
    }
    getContentSearchVersion = () =>{
        const {experiences} = this.configuration;
        if(experiences?.content_search_version)
            return experiences.content_search_versioon;
        else
            return 'v3'
    }
    getSearchKey = () =>{
        const {experiences} = this.configuration;
        if(experiences?.content_search_key)
            return experiences.content_search_key;
        else
            throw new Error('Missing content search key')
    }
    getContentSearchUrl = () => {
        const phpEnvName = window?.TVSite?.phpEnvName;
        const env = phpEnvName === "local" ? "test" : phpEnvName;
        const part = env === "app" ? "" : "."+env;
        const version = this.getContentSearchVersion();
        return `https://content${part}.creatable.io/graphql/${version}/${this.getSearchKey()}`;
    }
    getCreatorApplyUrl = () => {
        const hash = this.configuration?.client?.hash;
        if (!hash) return "";
        const phpEnvName = typeof window !== "undefined" ? window?.TVSite?.phpEnvName : null;
        const env = phpEnvName === "local" ? "test" : phpEnvName;
        if (!env) return "";
        const part = env === "app" ? "" : "." + env;
        return `https://creators${part}.creatable.io/${hash}/account/new`;
    }
    getProductCollectionsEnabled = () => {
        return this.configuration?.experiences?.storefront?.product_collections_enabled === true;
    }
    getSiteBaseUrlFromClientConfig = () => {
        const {public_base_url, sub_folder} = this.configuration.experiences.publishing;
        return (public_base_url + (sub_folder ? sub_folder : "")).replace(/\/$/, "").trim();
    }

}

export default new ClientConfigurationHelper();